import React, { useContext } from 'react';
import { Container } from 'react-bootstrap';
import ReportsList from './ReportsList';
import Section from '../Layouts/Section';
import Wrapper from '../Layouts/Wrapper';
import { ModalContext } from '../../store/modal-context';

const Reports = ({ reportDate, selectedDate, filteredPipelines, setFilteredPipelines, setReportLoading, reportRefreshTrigger, reportLoading }) => {
  const modalContext = useContext(ModalContext);
  
  return (
    <Container>
      <Wrapper className="reports pt-2 pb-5">
        <Section className="reports-list mb-5">
          <ReportsList 
            gitlabUrlAutomation={modalContext.gitlabUrlAutomation}
            PAT={modalContext.PAT}
            reportDate={reportDate}
            selectedDate={selectedDate}
            filteredPipelines={filteredPipelines}
            setFilteredPipelines={setFilteredPipelines}
            setReportLoading={setReportLoading}
            reportRefreshTrigger={reportRefreshTrigger}
            reportLoading={reportLoading}
          />
        </Section>
      </Wrapper>
    </Container>
  );
};

export default Reports; 